import { flashErrorMessage } from 'redux-flash'
import errorMessageFromFormErrors from './errorMessageFromFormErrors'
import { logEvent } from 'uxcam-service'

// Every redux-form routes submit failures through here, so it is also where
// UXCam learns a member hit a wall. Field *names* only, never typed values.
const UXCAM_EVENT = 'form_submission_failed'

const FAILURE_CATEGORY = {
  API: 'api',
  VALIDATION: 'validation',
}

// `Contact.js` names instances `ContactForm-<sfid>`. Logged as-is that is one
// `form` value per member, which can't be aggregated.
const formName = (form) =>
  typeof form === 'string' ? form.replace(/-[a-zA-Z0-9]{15,18}$/, '') : form

// A stable category instead of the flash message: `errorMessageFromFormErrors`
// falls back to the raw `formWideError` for unmapped API errors, so the text
// can carry backend- or member-supplied content.
function failureCategory(errors, submitError) {
  if (!errors || !Object.keys(errors).length) return undefined
  if (!submitError) return FAILURE_CATEGORY.VALIDATION

  return submitError?.meta?.error?.name === 'HttpError'
    ? FAILURE_CATEGORY.API
    : FAILURE_CATEGORY.VALIDATION
}

// Generate a flash error message for form submission failures
//
// `props` is redux-form's fourth onSubmitFail argument. Some callers pass only
// three (see StripePaymentStep), so the form name is optional.
export default function handleSubmitFailWithFlashMessage(
  errors,
  dispatch,
  submitError,
  props,
) {
  const errorMessage = errorMessageFromFormErrors(errors, submitError)
  errorMessage && dispatch(flashErrorMessage(errorMessage))

  logEvent(UXCAM_EVENT, {
    form: formName(props?.form),
    fields: Object.keys(errors ?? {})
      .filter((field) => field !== '_error')
      .join(', '),
    category: failureCategory(errors, submitError),
  })
}
